import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Mover, User } from "../../types";
import { RootState } from "../index";

interface MoversState {
  movers: Mover[];
  selectedMoverId: number | null;
  selectedMover: Mover | null;
  currentUser: User | null;
}

const initialState: MoversState = {
  movers: [],
  selectedMoverId: null,
  selectedMover: null,
  currentUser: null,
};

const moversSlice = createSlice({
  name: "movers",
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<User>) => {
      state.currentUser = action.payload;
    },
    setMovers: (state, action: PayloadAction<Mover[]>) => {
      state.movers = action.payload;
    },
    addMover: (state, action: PayloadAction<Mover>) => {
      state.movers.push(action.payload);
    },
    updateSelectedMover: (state, action: PayloadAction<Mover>) => {
      const index = state.movers.findIndex(
        (mover) => mover.id === action.payload.id
      );
      if (index !== -1) {
        state.movers[index] = action.payload;
      }
      state.selectedMover = action.payload;
    },
    deleteMover: (state, action: PayloadAction<number>) => {
      state.movers = state.movers.filter(
        (mover) => mover.id !== action.payload
      );
    },
    setSelectedMover: (state, action: PayloadAction<Mover>) => {
      state.selectedMover = action.payload;
    },
  },
});

export const getMovers = createSelector(
  (state: RootState) => state.movers,
  (movers) => movers.movers
);

export const getSelectedMover = createSelector(
  (state: RootState) => state.movers,
  (movers) => movers.selectedMover
);

export const getCurrentUser = createSelector(
  (state: RootState) => state.movers,
  (movers) => movers.currentUser
);

export const {
  setMovers,
  addMover,
  updateSelectedMover,
  deleteMover,
  setSelectedMover,
  setCurrentUser,
} = moversSlice.actions;

export default moversSlice.reducer;
